import React from 'react';

const ImportHistory = () => {
    return <h1>Import History</h1>;
};

export default ImportHistory;
